(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fys-home-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fys-home-faq__list').forEach((list) => {
    if (list.dataset.singleOpenBound === 'true') return;
    list.dataset.singleOpenBound = 'true';
    list.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (opened.tagName !== 'DETAILS' || !opened.open) return;
      list.querySelectorAll('details[open]').forEach((detail) => {
        if (detail !== opened) detail.open = false;
      });
    }, true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fys-home-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fys-reviews').forEach((section) => {
    if (section.dataset.carouselBound === 'true') return;
    section.dataset.carouselBound = 'true';

    const track = section.querySelector('.fys-reviews__track');
    const previous = section.querySelector('.fys-reviews__previous');
    const next = section.querySelector('.fys-reviews__next');
    if (!track || !previous || !next) return;

    const cards = Array.from(track.querySelectorAll('blockquote'));
    const readMoreButtons = Array.from(section.querySelectorAll('[data-read-more]'));
    const autoplayEnabled = section.dataset.autoplay === 'true';
    const delay = Math.max(Number(section.dataset.autoplayDelay) || 5000, 3000);
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    let resizeFrame = null;

    const step = () => {
      const card = cards[0];
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    };

    const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

    const goPrevious = () => {
      if (track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      else track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const goNext = () => {
      if (atEnd()) track.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      else track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    const stopAutoplay = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const hasExpandedReview = () => Boolean(section.querySelector('.fys-reviews__review-copy.is-expanded'));

    const startAutoplay = () => {
      stopAutoplay();
      if (
        !autoplayEnabled ||
        reduceMotion ||
        hasExpandedReview() ||
        cards.length < 2 ||
        track.scrollWidth <= track.clientWidth + 4
      ) return;
      timer = window.setInterval(goNext, delay);
    };

    const restartAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    const updateReadMoreButtons = () => {
      readMoreButtons.forEach((button) => {
        const copyId = button.getAttribute('aria-controls');
        const copy = copyId ? document.getElementById(copyId) : null;
        if (!copy) return;

        if (copy.classList.contains('is-expanded')) {
          button.hidden = false;
          return;
        }

        button.hidden = !(copy.scrollHeight > copy.clientHeight + 2);
      });
    };

    const scheduleReadMoreCheck = () => {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(updateReadMoreButtons);
    };

    previous.addEventListener('click', () => {
      goPrevious();
      restartAutoplay();
    });

    next.addEventListener('click', () => {
      goNext();
      restartAutoplay();
    });

    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goPrevious();
        restartAutoplay();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goNext();
        restartAutoplay();
      }
    });

    readMoreButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const copyId = button.getAttribute('aria-controls');
        const copy = copyId ? document.getElementById(copyId) : null;
        if (!copy) return;

        const expanded = copy.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;

        if (expanded) stopAutoplay();
        else startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', (event) => {
      if (!section.contains(event.relatedTarget)) startAutoplay();
    });

    window.addEventListener('resize', scheduleReadMoreCheck);
    scheduleReadMoreCheck();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleReadMoreCheck);
    }

    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-area-map"] && !Shopify.designMode) return;
  try {
    
  if (!window.__freshYardServiceAreaBound) {
    window.__freshYardServiceAreaBound = true;

    document.addEventListener('click', function(event) {
      const cityButton = event.target.closest('[data-city-chip]');
      const resetButton = event.target.closest('[data-reset-map]');

      if (!cityButton && !resetButton) return;

      const section = (cityButton || resetButton).closest('[data-service-area-section]');
      if (!section) return;

      const map = section.querySelector('[data-service-map]');
      const selection = section.querySelector('[data-city-selection]');
      const selectedName = section.querySelector('[data-selected-city-name]');
      const pageLink = section.querySelector('[data-city-page-link]');
      const chips = section.querySelectorAll('[data-city-chip]');

      if (resetButton) {
        const defaultMap = section.dataset.defaultMap;
        if (map && defaultMap) map.src = defaultMap;
        chips.forEach(function(chip) {
          chip.setAttribute('aria-pressed', 'false');
        });
        if (selection) selection.hidden = true;
        return;
      }

      const city = cityButton.dataset.city || '';
      const pageUrl = cityButton.dataset.pageUrl || '';
      const action = cityButton.dataset.action || 'zoom_link';

      if (action === 'page' && pageUrl) {
        window.location.assign(pageUrl);
        return;
      }

      chips.forEach(function(chip) {
        chip.setAttribute('aria-pressed', chip === cityButton ? 'true' : 'false');
      });

      if (map) {
        const customMapUrl = cityButton.dataset.mapUrl || '';
        const query = cityButton.dataset.mapQuery || city;
        map.src = customMapUrl || ('https://www.google.com/maps?q=' + encodeURIComponent(query) + '&output=embed');
      }

      if (selection && selectedName) {
        selectedName.textContent = city;
        selection.hidden = false;
      }

      if (pageLink) {
        if (pageUrl && action === 'zoom_link') {
          pageLink.href = pageUrl;
          pageLink.textContent = 'View ' + city + ' service page';
          pageLink.hidden = false;
        } else {
          pageLink.hidden = true;
          pageLink.removeAttribute('href');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
